import React from 'react';
import type { DateInput } from '@koob/dates';
import KoobSpinner from '@koob/ui/src/components/KoobSpinner';
import { formatCurrency } from '@koob/utils';
import ExternalFactsheetLink from '../ExternalFactsheetLink';
import {
  useVersionHotelDayPrice,
  useVersionHotelFactsheetHref,
} from '../../hooks/useTripVersionDayPrices';
import type { Translation } from './types';

export default function TripDayReadOnlyHotel({
  hotel,
  date,
  included,
  stayRooms,
  t,
}: {
  hotel: any;
  date: DateInput;
  included?: boolean;
  stayRooms: any;
  t: Translation;
}) {
  const href = useVersionHotelFactsheetHref(hotel);
  const { price, isLoading, isInProgress } = useVersionHotelDayPrice({
    hotel,
    date,
    included,
    stayRooms,
  });

  return (
    <div className="rounded-md border border-solid border-[#E7ECF3] bg-white p-3">
      <div className="flex space-x-2 pr-1.5">
        <div className="relative h-10 w-10 shrink-0 overflow-hidden rounded">
          <img
            src={
              hotel?.imageUrl ??
              hotel?.primaryAttachment?.imageUrl ??
              '/img/hotel-image-placeholder.png'
            }
            onError={(ev: any) =>
              (ev.target.src = '/img/hotel-image-placeholder.png')
            }
            className="absolute inset-0 h-full w-full rounded object-cover"
            alt=""
          />
        </div>

        <div className="min-w-0">
          <div className="text-xs font-medium text-gray-900">
            {/* AC08 — only the icon navigates. */}
            <ExternalFactsheetLink
              name={hotel?.name ?? hotel?.displayName ?? ''}
              href={href}
              label={t('compose.openHotelFactsheet')}
            />
          </div>

          <div className="mt-1 text-xs text-gray-500">{hotel?.address}</div>

          <div className="mt-2 text-sm font-medium">
            {included ? (
              <div className="text-green-500">{t('compose.priceIncluded')}</div>
            ) : (!price?.price && isLoading) || isInProgress ? (
              <KoobSpinner size={15} />
            ) : (
              price?.price && (
                <div
                  className="text-xs text-blue-600"
                  data-testid="version-day-hotel-price"
                >
                  {formatCurrency({
                    amount: price.price,
                    currency: price.currency,
                  })}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
